<!--
 * @Author: zhaozhuo
 * @Date: 2021-12-13 16:30:53
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-07-11 11:00:58
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\utilsComponents\fileUpload\index.vue
-->
<template>
  <div>
    <van-uploader v-model="fileInfoList"
                  :deletable="!(disable || formOption.isReadonly === dictionary.readonlyFlag[0].value) && !isUploadReadonly"
                  :disabled="disable || formOption.isReadonly === dictionary.readonlyFlag[0].value" :after-read="afterRead"
                  :readonly="isUploadReadonly" :multiple="multiple" :max-count="10"
                  :accept="formOption.controlType === 'PUF' ? imgFile : ''" @delete="deleteFile"
    />
    <p style="color: red;font-size: 10px;">上传文件,不超过10M</p>
  </div>
</template>
<script>
import * as dictionary from '@/assets/js/dictionary'
export default {
	props: {
		value: {
			type: Object,
			default: {}
		},
		disable: { // 禁止
			type: [Boolean, Number],
			default: false
		},
		multiple: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			dictionary,
			fileInfoList: [], // 文件展示列表
			isUploadReadonly: false, // 上传中设置上传文件为readonly
			imgFile: '.png, .jfif, .bmp, .gif, .jpg, .pic, .tif, .EPS, .SVG, .jpeg, .JPEG, .PNG, .TIFF'
		}
	},
	computed: {
		formOption: {
			get: function () {
				return this.value
			},
			set: function () {
				return
			}
		}
	},
	watch: {
		'formOption': {
			handler(newValue) {
				this.fileInfoList = newValue.fileList ? this.$utils.deepClone(newValue.fileList) : []
				this.formOption.fileList = this.formOption.fileList || []
				this.$emit('changePickerData', newValue)
			},
			deep: true,
			immediate: true
		}
	},
	methods: {
		// 上传成功
		afterRead(files, detail) {
			this.isUploadReadonly = true
			if (files.length) {
				// 多个文件
				for (const file of files) {
					file.status = 'uploading'
					file.message = '上传中...'
					this.uploadFile(file, detail)
				}
			} else {
				// debugger
				// 单个文件
				files.status = 'uploading'
				files.message = '上传中...'
				this.uploadFile(files, detail)
			}
			this.isUploadReadonly = false
		},
		// 上传文件
		async uploadFile(file, detail) {
			const res = await this.$api.file.uploadFile(file.file)
			console.log(res)
			if (res && res.code === 200) {
				const resData = res.data || {}
				this.formOption.fileList.push({
					...resData
				})
				this.formOption.value = this.formOption.fileList
				file.status = 'done'
				file.message = '上传成功'
			} else {
				file.status = 'failed'
				file.message = '上传失败'
				this.fileInfoList.splice(detail.index, 1)
				this.$toast.fail('上传失败')
			}
		},
		// 删除文件
		deleteFile(file, detail) {
			this.formOption.value.splice(detail.index, 1)
		}
	}
}
</script>
<style lang="scss" scoped></style>